
    <!-- [trackByFn]="trackByFn" -->
    <mat-label class="custom-label" [ngClass]="{'d-none': !to.customLabel }">{{ to.customLabel }}
      <span *ngIf="to.required">*</span>
    </mat-label>
    <ng-select
      [items]="options$ | async"
      [bindValue]="to.bindValue"
      [bindLabel]="to.bindLabel"
      [multiple]="to.multiple"
      [hideSelected]="to.hideSelected"
      [typeahead]="optionsInput$"
      [loading]="optionsLoading"
      [(ngModel)]="value"
      [placeholder]="to.placeholder"
      [minTermLength]="to.minTermLength"
      [typeToSearchText]="to.typeToSearchText"
      [clearAllText]="to.clearAllText"
      [addTag]="addTag.bind(this)"
      [addTagText]="to.addTagText"
      [notFoundText]="to.notFoundText"
      [loadingText]="to.loadingText"
      (change)="onChange($event)"
      [disabled]="to.disabled"
      [readonly]="to.readonly"
      [required]="to.required"
      [ngClass]="{'autocomplete-invalid': !value && to.required }"
      >
    </ng-select>
    <div *ngIf="!value && to.required" class="mat-error" style="font-size: 75%; padding: 0.4375em 0;">
      Il campo è richiesto
    </div>
  